import { render, staticRenderFns } from "./EditPersonalInfo.vue?vue&type=template&id=1811a4ff&scoped=true&"
import script from "./EditPersonalInfo.vue?vue&type=script&lang=js&"
export * from "./EditPersonalInfo.vue?vue&type=script&lang=js&"
import style0 from "./EditPersonalInfo.vue?vue&type=style&index=0&id=1811a4ff&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1811a4ff",
  null
  
)

export default component.exports